












































































































import Vue from 'vue';
import { IBarometerDataOverview, IBarometerDataPoints } from '@/common/interfaces/barometer.interface';
import config from '../../../../../config';
import FormatHelper from '@/helpers/FormatHelper';
import RevenueBarometerOverview from '../components/RevenueBarometerOverview.vue';
import Tooltip from '@/components/layout/popper/Tooltip.vue';

interface IRevenueBarometerDesktopComponent {
  FormatHelper: typeof FormatHelper;
  wpUrls: Record<string, unknown>;
}

export default Vue.extend({
  components: { RevenueBarometerOverview, Tooltip },
  data(): IRevenueBarometerDesktopComponent {
    return {
      FormatHelper,
      wpUrls: config.wpUrls,
    };
  },
  props: {
    disableNavigationButton: {
      default: false,
      type: Boolean,
    },
    overviewData: {
      required: true,
      type: Object as () => IBarometerDataOverview,
    },
    pointsData: {
      required: true,
      type: Object as () => Partial<IBarometerDataPoints>,
    },
  },
});
